import { useClientsCommandActions } from '../../hooks/useClientsCommandActions';
import { useCreateCommandAction } from '../../hooks/useCreateCommandAction';
import { useInviteMemberCommandAction } from '../../hooks/useInviteCommandAction';

export const GeneralCommandbarActionsInitializer = () => {
  // setup create entity command actions
  useCreateCommandAction();
  /** register view client details command actions */
  useClientsCommandActions();
  // setup invite member command actions
  useInviteMemberCommandAction();

  return null;
};
